import React, { useState, useEffect, useContext } from "react";
import FeedbackService from "../services/FeedbackService";
import NewFeedbackModal from "./modals/NewFeedbackModal"
import { FaCircle } from "react-icons/fa";
import { parseISO, format } from "date-fns";
import { Context } from '../context/UserContext'
import FeedbackDetailsModal from './modals/FeedbackDetailsModal';

export default function Feedbacks() {

  const statusColor = {
    "NOVO": "#fde047",
    "EM ANDAMENTO": "#38bdf8",
    "FINALIZADO": "#22c55e"
  }

  const { user } = useContext(Context)

  const [feedbackListNovos, setfeedbackListNovos] = useState([]);
  const [feedbackListEmAndamento, setFeedbackListEmAndamento] = useState([]);
  const [feedbackListFinalizados, setFeedbackListFinalizados] = useState([]);
  const [feedbackCreateModal, setFeedbackCreateModal] = useState(false);

  const [feedbackDetailsModal, setFeedbackDetailsModal] = useState(false);
  const [feedbackOnDetailsModal, setFeedbackOnDetailsModal] = useState();

  async function fetchFeedbacks() {

    const feedbacksNovos = await FeedbackService.getFeedbacks('?status=NOVO');
    setfeedbackListNovos(feedbacksNovos);

    const feedbacksEmAndamento = await FeedbackService.getFeedbacks('?status=EM ANDAMENTO');
    setFeedbackListEmAndamento(feedbacksEmAndamento);
    
    const feedbacksFinalizados = await FeedbackService.getFeedbacks('?status=FINALIZADO');
    setFeedbackListFinalizados(feedbacksFinalizados);

  }

  const handleFeedbackDetailsModal = async (ticketId) => {
    setFeedbackDetailsModal(true)
    setFeedbackOnDetailsModal(ticketId)
  };


  useEffect(() => {   
    
    fetchFeedbacks();

    }, [feedbackCreateModal, feedbackDetailsModal]);


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-12 bg-white">

        <div className="flex flex-col gap-2">
          <div className="flex">
            <div className="w-full text-md font-semibold">
              Todas os Feedbacks
            </div>
            <button onClick={()=>setFeedbackCreateModal(true)} className="flex justify-center items-center bg-sky-600 px-2 py-1 rounded-lg text-white gap-2 whitespace-nowrap">
              <div>+ Criar Feedback</div>
            </button>
          </div>

          

          <div className="w-full">
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white rounded-lg text-xs">
                <thead className="bg-neutral-200">
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg w-32">Status</th>
                    <th className="py-2 px-4 border-b min-w-32">Protocolo</th>
                    <th className="py-2 px-4 border-b min-w-32">Criado em</th>
                    <th className="py-2 px-4 border-b min-w-32">Criado por</th>
                    <th className="py-2 px-4 border-b min-w-32">Descrição</th>
                    {user.email === 'junior.silva@amerinode.com.br' && // permitido apenas pro ADM, irá modificar quando implementar o controle de acessos
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {feedbackListEmAndamento?.feedbacks?.map((feedback, index) => (
                    <tr key={index} className="border-b hover:bg-gray-100">
                      <td className="py-1 px-4">
                        <div className="flex justify-start items-center gap-2 whitespace-nowrap">
                          <FaCircle
                          color={statusColor[feedback.status]}
                          size={15}
                          />
                        {feedback.status}
                        </div>
                      </td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{feedback.protocol}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{format(parseISO(feedback.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{feedback.user.name}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-start items-center">{feedback.description}</div></td>
                      {user.email === 'junior.silva@amerinode.com.br' && // permitido apenas pro ADM, irá modificar quando implementar o controle de acessos
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2">  
                              <button
                                className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                                onClick={()=>handleFeedbackDetailsModal(feedback._id)}
                              >
                                Editar
                              </button>
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          
          <div className="w-full">
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white rounded-lg text-xs">
                <thead className="bg-neutral-200">
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg w-32">Status</th>
                    <th className="py-2 px-4 border-b min-w-32">Protocolo</th>
                    <th className="py-2 px-4 border-b min-w-32">Criado em</th>
                    <th className="py-2 px-4 border-b min-w-32">Criado por</th>
                    <th className="py-2 px-4 border-b min-w-32">Descrição</th>
                    {user.email === 'junior.silva@amerinode.com.br' && // permitido apenas pro ADM, irá modificar quando implementar o controle de acessos
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {feedbackListFinalizados?.feedbacks?.map((feedback, index) => (
                    <tr key={index} className="border-b hover:bg-gray-100">
                      <td className="py-1 px-4">
                        <div className="flex justify-start items-center gap-2 whitespace-nowrap">
                          <FaCircle
                          color={statusColor[feedback.status]}
                          size={15}
                          />
                        {feedback.status}
                        </div>
                      </td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{feedback.protocol}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{format(parseISO(feedback.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{feedback.user.name}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-start items-center">{feedback.description}</div></td>
                      {user.email === 'junior.silva@amerinode.com.br' && // permitido apenas pro ADM, irá modificar quando implementar o controle de acessos
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2">
                              
                              <button
                                className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                                onClick={()=>handleFeedbackDetailsModal(feedback._id)}
                              >
                                Editar
                              </button>
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="w-full">
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white rounded-lg text-xs">
                <thead className="bg-neutral-200">
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg w-32">Status</th>
                    <th className="py-2 px-4 border-b min-w-32">Protocolo</th>
                    <th className="py-2 px-4 border-b min-w-32">Criado em</th>
                    <th className="py-2 px-4 border-b min-w-32">Criado por</th>
                    <th className="py-2 px-4 border-b min-w-32">Descrição</th>
                    {user.email === 'junior.silva@amerinode.com.br' && // permitido apenas pro ADM, irá modificar quando implementar o controle de acessos
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {feedbackListNovos?.feedbacks?.map((feedback, index) => (
                    <tr key={index} className="border-b hover:bg-gray-100">
                      <td className="py-1 px-4">
                        <div className="flex justify-start items-center gap-2 whitespace-nowrap">
                          <FaCircle
                          color={statusColor[feedback.status]}
                          size={15}
                          />
                        {feedback.status}
                        </div>
                      </td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{feedback.protocol}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{format(parseISO(feedback.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center">{feedback.user.name}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-start items-center">{feedback.description}</div></td>
                      {user.email === 'junior.silva@amerinode.com.br' && // permitido apenas pro ADM, irá modificar quando implementar o controle de acessos
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2">
                              
                              <button
                                className=" bg-sky-700 rounded-full px-2 py-1 text-white text-sm"
                                onClick={()=>handleFeedbackDetailsModal(feedback._id)}
                              >
                                Editar
                              </button>
                          </div>
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>

      <div className="absolute">
        <NewFeedbackModal
          isModalOpen={feedbackCreateModal}
          setModalOpen={() => {
            setFeedbackCreateModal(!feedbackCreateModal);
          }}
          // setTicketCb={setTicket}
        ></NewFeedbackModal>
      </div>

      {feedbackOnDetailsModal && //validation to prevent to call undefined
        <div className="absolute">
          <FeedbackDetailsModal
            isModalOpen={feedbackDetailsModal}
            setModalOpen={() => {
              setFeedbackDetailsModal(!feedbackDetailsModal);
            }}
            feedbackId={feedbackOnDetailsModal}
            // setTicketCb={setTicket}
          ></FeedbackDetailsModal>
        </div>
      }


    </div>
  )
}
